const e = "style-module__fileName___EFcui", n = "style-module__icon___-ee-4", t = "style-module__receiver___EuJeI", _ = "style-module__filePreviewContainer___jCqRg", o = "style-module__contextMenuContainer___xgHLv", l = "style-module__contextMenu___6qG7n", i = "style-module__fileImageContainer___b8ANp", r = "style-module__fileImage___ES8CE", s = "style-module__textContent___HsktQ", a = "style-module__sender___XwbQ8", c = "style-module__noPreviewContainer___PGDRv", m = "style-module__bgOverlay___P-Ojf", u = {
  fileName: e,
  icon: n,
  receiver: t,
  filePreviewContainer: _,
  contextMenuContainer: o,
  contextMenu: l,
  fileImageContainer: i,
  fileImage: r,
  textContent: s,
  sender: a,
  noPreviewContainer: c,
  bgOverlay: m
};
export {
  m as bgOverlay,
  l as contextMenu,
  o as contextMenuContainer,
  u as default,
  r as fileImage,
  i as fileImageContainer,
  e as fileName,
  _ as filePreviewContainer,
  n as icon,
  c as noPreviewContainer,
  t as receiver,
  a as sender,
  s as textContent
};
